import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@common-web/components/ui/alert-dialog';
import {Button} from '@common-web/components/ui/button';
import {Download} from 'lucide-react';

export function SkipInvalidAlert({
  onSkipInvalidRows,
  invalidRowCount,
  onExportInvalidRows,
}: {
  onSkipInvalidRows: () => void;
  invalidRowCount: number;
  onExportInvalidRows: () => void;
}) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <div className='ml-auto'>
          <Button
            variant='outline'
            className='bg-white border-red-700 text-red-700 hover:border-red-800 hover:text-red-800'
          >
            Skip invalid rows and proceed
          </Button>
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Skip invalid rows and proceed</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          Are you sure you would like to skip {invalidRowCount} invalid row
          {invalidRowCount === 1 ? '' : 's'} and proceed? These members will be deactivated if you
          continue.
          <div className='mt-4'>
            <Button
              variant='link'
              size='sm'
              onClick={onExportInvalidRows}
              className={'text-internal-brand-blue'}
            >
              <Download className='h-4 w-4 mr-2' /> Export invalid rows as CSV
            </Button>
          </div>
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              onSkipInvalidRows();
            }}
            className='bg-red-600 hover:bg-red-700 text-white'
          >
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
